import './assets/main.css'
import 'primeflex/primeflex.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

import authService from './services/authService'
import { enableDemoMode, isDemoActive } from './services/demoMode'
import { useAuthStore } from './stores/authStore'

import PrimeVue from 'primevue/config'
import Tooltip from 'primevue/tooltip'
import { useOrganizationStore } from './stores/organizationStore'
import KollPreset from './themes/koll-theme'
import ToastService from 'primevue/toastservice'
import * as Sentry from '@sentry/vue'
import { ENV } from './env'
import { reloadForStaleChunk } from './utils/chunkReload'

window.addEventListener('vite:preloadError', (event) => {
  if (reloadForStaleChunk(event.payload)) {
    event.preventDefault()
  }
})

const app = createApp(App)
const pinia = createPinia()

if (!ENV.backendUrl?.includes('localhost')) {
  Sentry.init({
    app,
    dsn: 'https://4dad769516ca29bcac4ec0d77dafebf9@o4508341553594368.ingest.de.sentry.io/4509127942799440',
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

app.use(pinia)
app.use(router)

app.use(PrimeVue, {
  ripple: true,
  theme: {
    preset: KollPreset,
    options: {
      darkModeSelector: '.dark',
    },
  },
})

app.use(ToastService)

app.directive('tooltip', Tooltip)

// Setup initial auth and org state
const authStore = useAuthStore()
const organizationStore = useOrganizationStore()
if (isDemoActive()) {
  // Demo mode: fixtures + a fake session, no real backend calls.
  enableDemoMode()
} else if (authStore.token) {
  authService.setupAuth(authStore.token)
  authService
    .getCurrentUser()
    .then((user) => {
      authStore.$patch({ user })
      organizationStore.fetchCurrentOrganization()
    })
    .catch(() => {
      authStore.clearAuth()
    })
}

app.mount('#app')
